import { useDeletePendingStatus } from "./api/deletePendingStatus";
import { Button } from "reactstrap";


const DeletePendingStatus = ({handleCloseModal, pendingStatusId}: DeletePendingStatusProps)  => {
  
  const deletePendingStatusMutation = useDeletePendingStatus({ pendingStatusId});
  const handleSubmit = async (): Promise<void> => {
    deletePendingStatusMutation.mutateAsync({ 
      pendingStatusId: pendingStatusId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Κατηγορία Εκκρεμότητας;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeletePendingStatusProps{
  pendingStatusId: number;
  handleCloseModal: () => void;
}

export default DeletePendingStatus;